<template>
    <!-- eslint-disable max-len -->
    <b-form inline class="bpc-table-header d-flex justify-content-between bd-highlight p-3">
          <div class="bpc-table-filters">

            <b-input-group v-if="filters.search" class="mr-2 search">
              <b-form-input v-model="filter" placeholder="Search..." />
              <b-input-group-append>
                <!-- <b-btn :disabled="!filter" @click="filter = ''" variant="light">
                  <font-awesome-icon icon="times"/>
                </b-btn> -->
                <b-btn @click="filter = ''" variant="light" style="background-color: white; border-left: 0;">
                  <font-awesome-icon v-bind:class="{ hide: !filter }" icon="times"/>
                  <font-awesome-icon v-bind:class="{ hide: filter }" icon="search"/>
                </b-btn>
              </b-input-group-append>
            </b-input-group>

            <b-dropdown id="dropdown-left" variant="light" class="mr-2">
              <span slot="button-content">Tags<span class="badge badge-pill badge-light">2</span></span>
              <b-dropdown-item href="#">Customer</b-dropdown-item>
              <b-dropdown-item href="#">Provider</b-dropdown-item>
              <b-dropdown-item href="#">Coach</b-dropdown-item>
              <b-dropdown-item href="#">Player</b-dropdown-item>
            </b-dropdown>

            <b-form-select v-model="type" class="mr-2">
              <option slot="first" :value="null">Type</option>
              <option>Individual</option>
              <option>Club</option>
              <option>School</option>
              <option>Company</option>
              <option>Other</option>
            </b-form-select>

            <b-form-select v-model="status" class="mr-2">
              <option slot="first" :value="null">Status</option>
              <option>Active</option>
              <option>Inactive</option>
            </b-form-select>

            <b-button v-if="filters.more" variant="link" class="more-filters">More filters</b-button>

          </div>

          <div class="bpc-table-pagination">
            <label class="mx-2">{{(pagination.currentPage - 1) * pagination.perPage + 1}} - {{Math.min(pagination.currentPage * pagination.perPage, totalRows)}} / {{totalRows}}</label>
            <b-form-select :options="pagination.pageOptions" v-model="pagination.perPage" class="ml-2" />
            <b-input-group class="ml-2">
              <b-form-select v-model="pagination.sortBy" :options="sortOptions">
                <option slot="first" :value="null">Sort by</option>
              </b-form-select>
              <b-form-select :disabled="!pagination.sortBy" v-model="pagination.sortDesc" slot="append" class="bg-light" style="border-top-left-radius: 0; border-bottom-left-radius: 0;">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
            <b-button-group class="ml-2">
              <b-button variant="light" :disabled="pagination.currentPage == 1" v-on:click="pagination.currentPage -= 1"><font-awesome-icon icon="angle-left"/></b-button>
              <b-button variant="light" :disabled="pagination.currentPage * pagination.perPage > totalRows" v-on:click="pagination.currentPage += 1"><font-awesome-icon icon="angle-right"/></b-button>
            </b-button-group>

            <!-- <b-button-group class="ml-2">
              <b-button variant="light" :disabled="view == 'table'" v-on:click="changeViewTo('table')"><font-awesome-icon icon="bars"/></b-button>
              <b-button variant="light" :disabled="view == 'cards'" v-on:click="changeViewTo('cards')"><font-awesome-icon icon="th"/></b-button>
            </b-button-group> -->

          </div>
      </b-form>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSearch,
  faTimes,
  faAngleLeft,
  faAngleRight,
  faTh,
  faBars,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faSearch,
  faTimes,
  faAngleLeft,
  faAngleRight,
  faTh,
  faBars,
);

export default {
  components: {
    // Multiselect,
    'font-awesome-icon': FontAwesomeIcon,
  },
  props: {
    fields: Array,
    filters: Object,
    pagination: Object,
    totalRows: Number,
  },
  data: () => ({
    view: String,
    filter: null,
    type: null,
    status: null,
    options: [
      { countryCode: 'AU', countryName: 'Australia' },
      { countryCode: 'CA', countryName: 'Canada' },
      { countryCode: 'CN', countryName: 'China' },
      { countryCode: 'DE', countryName: 'Germany' },
      { countryCode: 'JP', countryName: 'Japan' },
      { countryCode: 'MX', countryName: 'Mexico' },
      { countryCode: 'CH', countryName: 'Switzerland' },
      { countryCode: 'US', countryName: 'United States' },
    ],

    selected2: ['foo', 'bar'],
    options2: ['foo', 'bar', 'baz', 'Green', 'Blue', 'Orange'],

    selected3: null,
    options3: ['list', 'of', 'options'],

  }),
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
  },
  // methods: {
  //   changeViewTo(newView) {
  //     this.view = newView;
  //     console.log(this.view);
  //   },
  // },
};
</script>

<style>
  .bpc-table-header.d-flex > * {
    flex: none !important;
    flex-direction: row;
    flex-wrap: nowrap;
    display: flex;
  }
  .bpc-table-header :focus {
    outline: 0px !important;
    -webkit-appearance: none;
    box-shadow: none !important;
    border: 0;
  }
  .bpc-table-header select, .bpc-table-header .btn:not(.more-filters) {
    border: 0;
    background-color: #eee;
    /* border-left: 1px solid #dadada; */
  }
  .bpc-table-header .search input {
    border: 1px solid #dadada !important;
    border-right: 0 !important;
    width: 80px;
  }
  .bpc-table-header .search input:focus {
    width: 150px;
  }
  .bpc-table-header .search .btn {
    border: 1px solid #dadada !important;
    border-left: 0 !important;
  }
  .bpc-table-header .search .hide {
    color: white;
    display: none;
  }
</style>
